﻿window.HandleEmailSuccess = function (response, element) {
    var isValid = false;

    if (!response.IsBadRequest) {
        isValid = true;
    }
    else {
        $(element).data("errMessage", response.ErrDescription);
    }

    //$('.form').find('input[class~="id-number"]').closest('.input-field-wrap').find('.input-field-spinner').hide();
    return isValid;
};

window.enableDisableEmail = function (enable) {
    if (enable) {
        $('.email, .email-pesel').removeAttr('readonly');
        $('.email, .email-pesel').attr('style', 'Background:white');
    }
    else {
        $('.email, .email-pesel').attr('readonly', 'readonly');
        $('.email, .email-pesel').attr('style', 'Background:#f8f8f8');
    }
};

////window.resetCaptchaOTPCounter = function (response) {
////    //alert('resetCaptchaOTPCounter ' + response);
////    getAjaxData("/api/sitecore/Login/ResetCaptchaOTPCounter", "POST", false, null, function (data) {
////        if (data) {
////            var a = 0; //Just dummy
////        }
////    });
////};

window.onLoadOTP = function (input) {
    $(".loading-sceen").show();

    var otpFailureCounter = 0;
    getAjaxData("/api/sitecore/Login/GetOTPFailureCounter", "POST", false, null, function (data) {
        if (data.success) {
            otpFailureCounter = data.OTPFailureCounter;
        }
    });

    var encryptedEmail = getParameterValues('ulemad');
    var activationCode = getParameterValues('uacec');
    var userToken = getParameterValues('utokc');
    //encryptedEmail = encryptedEmail.replace('==', '=');

    $('[data-validator-id="login-otp-user-token"]').val(userToken);
    $('[data-validator-id="login-home-email-address"]').val(encryptedEmail);
    $('[data-validator-id="login-otp-activation-code"]').val(activationCode);

    var VerifyForgotPasswordLinkInputType = {
        "EncryptedEmail": encryptedEmail,
        "ActivationCode": activationCode,
        "UserToken": userToken
    };
    getAjaxData("/api/sitecore/Login/OnLoadOTP", "POST", false, VerifyForgotPasswordLinkInputType, function (data) {
        if (!data.IsVerifySuccess && activationCode.trim().length > 0) {
            $('.login-verify-fail-div').attr("style", "display:block");
            $('.login-otp-div').attr("style", "display:none");
        }
        if ((!data.IsVerifySuccess && activationCode.trim().length == 0)
            || (data.IsVerifySuccess && activationCode.trim().length > 0)) {
            $('.email, .email-pesel').focus();
            //$('.email, .email-pesel').val(data.Email); 
            //read email from local storage
            $('.email, .email-pesel').val(localStorage.getItem('emailcheck'));
            $('.email, .email-pesel').focus();
            enableDisableEmail(false);
            $('.otp').focus();
            //$('.otp').blur();
            //$('.otp').focus();

            var failureCounterLimit = $('[data-validator-id="forgot-pwd-otp-failure-counter"]').val();
            var mobileNumberText = $('.mobile-no').find('p.mobile-no-text').html();
            if (data.MobileNumber.trim() == '') {
                data.MobileNumber = 'XXX XXX XXX';
            }
            mobileNumberText = mobileNumberText.replace("XXXXXX", data.MobileNumber);
            $('.mobile-no').find('p.mobile-no-text').html(mobileNumberText);

            if (otpFailureCounter == failureCounterLimit) {
                $('.otp-verify').prop('disabled', true);
                $(".otp-blocked-error").attr('style', 'display:block;');
            }
            else {
                $('.otp-verify').prop('disabled', false);
            }

            OnPageLoadShowError();

            window.addEventListener('load', () => {
                $(".loading-sceen").hide();
            }, false);
        }

        //if (!IsResendOTPSuccess) {
        //    $('.resend-otp-error').attr("style", "display:block");            
        //    $('.resend-otp-error').attr("style", "display:block");  
        //}
    }, function () {
        $(".loading-sceen").hide();
    });

    //GetDecryptedEmail("/api/sitecore/Login/GetDecryptedEmail", "POST", false, encryptedEmail, function (data) {
    //    if (data.success) {
    //        $('.email, .email-pesel').val(data.email);
    //    }
    //});        
};

window.getParameterValues = function (name) {
    var finalResult = '';
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    if (name == 'email') {
        finalResult = results[0].replace('?email=', '');
    }
    else {
        if (finalResult != null)
            finalResult = results[1];
    }
    return finalResult;
    //return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

window.hideReCaptcha = function (response) {
    $('.div-recaptcha-id').attr("style", "display:block;height:0px;width:0px;border:0px;visibility:collapse;margin-bottom:0px;");
};

window.reCaptchaCallback = function (response) {
    var recaptchaResponse = grecaptcha.getResponse();
    if (recaptchaResponse.length != 0) {
        $('.googleRecaptchaClass').val(recaptchaResponse);
        $(".resend-otp").attr('style', 'display:block;');
        ////resetCaptchaOTPCounter();

        hideReCaptcha();
        grecaptcha.reset();
    }
};

window.OnPageLoadShowError = function (response) {
    var pageName = {
        "pageName": 'OTP'
    };
    $(".loading-sceen").show();
    getAjaxData("/api/sitecore/Login/OnPageLoadShowError", "POST", true, pageName, function (data) {
        if (data) {
            //if (data.EmailID.trim().length == 0) {
            //    //$('.login-div').attr("style", "display:none");
            //    //$('.login-otp-div').attr("style", "display:none");
            //}
            //else {
            //    $('[data-validator-id="login-otp-user-token"]').val(data.UserToken);

            if (data.ErrorCode != null && data.ErrorCode.length > 0) {
                $('.form').find('.form-error-global').removeClass('hidden');
                $('.otp').closest('.form-row').find('span.form-error').html(data.ErrorMessage);
            }
            //}
        }
    }, function () {
        $(".loading-sceen").hide();
    });
};

export default class LoginOTP {
    constructor() {
        this.dom = {
            $: window.$
        };
        this.init();
    }
    init() {
        this.onLoad();

        this.setCaptchaValueOnSubmitClick();
        this.validateCaptcha();
        this.resendRegistrationOTP();
        //this.sendRegistrationOTP();

        this.submitClick();
    }

    onLoad() {
        hideReCaptcha();
        ////resetCaptchaOTPCounter();
        onLoadOTP();
    }

    submitClick() {
        $('.otp-verify').click(function (e) {
            localStorage.setItem('otpProvided', $('.otp').val());
            // $('[data-validator-id="can-resend-otp"]').val('no');
        });
    }


    resendRegistrationOTP() {
        $('.resend-otp').click(function (e) {
            $(".loading-screen").show();
            var btn = $(e.currentTarget);

            // If already disabled, do nothing
            if (btn.data('disabled')) {
                return false;
            }

            var cooldownTime = $('[data-validator-id="resend-otp-cooldown-period"]').val();
            cooldownTime = cooldownTime ? parseInt(cooldownTime) : 60;

            var waitText = $('[data-validator-id="please-wait-text"]').val();
            waitText = waitText ? waitText : 'Proszę czekać';

            var originalText = $('.resend-otp').text();

            // Disable the link
            btn.data('disabled', true);
            btn.css('pointer-events', 'none');
            btn.css('opacity', '0.5'); // Optional: visual feedback
            btn.text(waitText + ' '+ cooldownTime + ' s...');

            // Countdown timer (optional)
            var seconds = cooldownTime;
            
            var interval = setInterval(function () {
                seconds--;
                btn.text(waitText + ' ' + seconds + 's...');

                if (seconds <= 0) {
                    clearInterval(interval);
                    btn.removeData('disabled');
                    btn.css('pointer-events', 'auto');
                    btn.css('opacity', '1');
                    btn.text(originalText);
                }
            }, 1000);

            $('.otp-verify').prop('disabled', false);
            $(".resend-otp-success").attr('style', 'display:none;');
            $(".resend-otp-error").attr('style', 'display:none;');
            e.preventDefault();
            var encryptedEmail = $('[data-validator-id="login-home-email-address"]').val();
            var LoginEmailInputType = {
                "LoginEmailAddress": encryptedEmail,
                "UserToken": $('[data-validator-id="login-otp-user-token"]').val(),
                "CooldownTime": cooldownTime
            };
            getAjaxData("/api/sitecore/Login/ResendRegistrationOTP", "POST", true, LoginEmailInputType, function (data) {
                if (data) {
                    if (data.IsSuccess) {
                        $('.otp').val('');
                        $('.otp').focus();
                        $(".resend-otp-success").attr('style', 'display:block;');
                        $(".resend-otp-error").attr('style', 'display:none;');
                        $(".otp-blocked-error").attr('style', 'display:none;');
                    }
                    else {
                        $(".resend-otp-success").attr('style', 'display:none;');
                        $(".resend-otp-error").attr('style', 'display:block;');
                        $(".notification").attr('style', 'display:none;');
                    }
                    //ReCaptcha show/hide
                    if (data.OtpSentCounter == 3) {
                        $('.div-recaptcha-id').attr("style", "display:block");
                        $('.googleRecaptchaClass').val('');
                        ////resetCaptchaOTPCounter();
                        $(".resend-otp").attr('style', 'display:none;');
                    }
                    else {
                        if ($('.googleRecaptchaClass').val().trim() != '') {
                            hideReCaptcha();
                            grecaptcha.reset();
                            //$(".resend-otp-success").attr('style', 'display:none;');
                            //$(".resend-otp-error").attr('style', 'display:none;');
                        }
                    }


                    //////ReCaptcha show/hide
                    ////if (data.ReCaptchaCounter > 2) {
                    ////    $('.div-recaptcha-id').attr("style", "display:block");
                    ////    $('.googleRecaptchaClass').val('');
                    ////    ////resetCaptchaOTPCounter();
                    ////    $(".resend-otp").attr('style', 'display:none;');
                    ////}
                    ////else {
                    ////    if ($('.googleRecaptchaClass').val().trim() != '') {
                    ////        hideReCaptcha();
                    ////        grecaptcha.reset();
                    ////    }
                    ////}
                }
                $(".loading-screen").hide();
            });
        });
    }

    validateCaptcha() {
        var that = this;
        var keys = { "keys": ["CAPTCHA_REQUIRED"] };
        getAjaxData("/api/sitecore/validations/GetValidationMessages", "POST", false, keys, function (data) {
            if (data) {
                $.validator.addMethod('validateCheckCaptcha', function (value, element) {
                    return that.verifyCaptcha();
                }, data["CAPTCHA_REQUIRED"]);

                $.validator.addClassRules('googleRecaptchaClass', { validateCheckCaptcha: true });
            }
        });
    }

    verifyCaptcha() {
        if ($('.div-recaptcha-id').css('visibility') == 'collapse') {
            return true;
        }
        var response = $('.googleRecaptchaClass').val().trim();
        var isValid = false;
        ////resetCaptchaOTPCounter();
        return isValid;
    }

    setCaptchaValueOnSubmitClick() {
        $('.recaptcha').click(function (e) {
            localStorage.setItem('otpProvided', $('.otp').val());
            var recaptchaResponse = grecaptcha.getResponse();
            //cLog(recaptchaResponse);
            //cLog(recaptchaResponse.length);
            if (recaptchaResponse.length != 0) {
                $('.googleRecaptchaClass').val(recaptchaResponse);
                ////resetCaptchaOTPCounter();
            }

        });
    }


}

document.addEventListener('DOMContentLoaded', () => new LoginOTP());
